<div class="editor-shell" [class.source-mode]="sourceMode">
  @if (!sourceMode) {
  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" [customMenuRef]="customMenu"></ngx-editor-menu>
  <ngx-editor [editor]="editor" [ngModel]="model" (ngModelChange)="onModelChange($event)" outputFormat="html" [placeholder]="placeholder"></ngx-editor>
  }
  @if (sourceMode) {
  <button class="custom-menu-button source-mode-toggle" type="button" (click)="toggleSourceMode()">Volver al editor</button>
  <textarea [(ngModel)]="sourceCode" class="source-editor" aria-label="Código HTML"></textarea>
  }
  <ng-template #customMenu>
    <button class="custom-menu-button" type="button" (click)="toggleSourceMode()">Código</button>
    <button class="custom-menu-button" type="button" (click)="openPreview()">Previsualizar</button>
    <select class="conf-key-selector" aria-label="Insertar campo de configuración" (change)="insertCampo($any($event.target).value, $any($event.target))">
      <option value="">$Conf_IDX</option>
      @for (key of confKeys; track key) {
      <option [value]="key">{{ key }}</option>
      }
    </select>
  </ng-template>
</div>
<nz-modal [(nzVisible)]="previewVisible" (nzOnCancel)="handlePreviewCancel()" [nzClosable]="false" [nzFooter]="null">
  <ng-container *nzModalContent><div class="preview-box" [innerHTML]="previewHtml"></div></ng-container>
</nz-modal>
